<template>
  <div class="info">
    <div class="info-properties">
      <h2>Info</h2>
      <div class="param" v-for="property in info.properties" :key="property.key">
        <p class="param-name">{{property.key}}</p>
        <p v-if="property.value.startsWith('http')"><a target="_blank" :href="property.value">{{property.value}}</a></p>
        <p v-else>{{property.value}}</p>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Info',
  props: {
    info: {
      type: Object,
      requierd: true  
    }
  }
}
</script>

<style>
.info {
  background-color: white;
  text-align: left;
  
}
.info h2 {
  text-align: center;
  margin: 5px 10px;
}
.info-properties {
  background-color: #eee;
  display: inline-block;
  border: 1px solid grey;
}
.param-name {
  font-size: 12px;
  width: 70px;
}
</style>